<template>
  <section class="services py-5">
    <b-container>
      <!-- Section Title -->
      <b-row class="text-center mb-5">
        <b-col>
          <h2 class="fw-bold mb-2 color-bar">Our Services</h2>
          <p class="text-muted mx-auto section-desc">
            As a full-fledged integrated corporate security and communication company, we offer unique and qualitative services in the following core areas to meet in a special way, the numerous and diverse peculiar needs of our clientele; comprising individuals, small scale enterprises, financial institutions, multi-national companies and government parastatals.
          </p>
        </b-col>
      </b-row>

      <!-- Services Cards -->
      <b-row>
        <b-col md="4" class="mb-4" v-for="(service, index) in services" :key="index">
          <b-card class="text-center h-100 service-card">
            <b-icon
              :icon="service.icon"
              variant="primary"
              font-scale="3"
              class="mb-3 color-bar"
            ></b-icon>

            <h5 class="fw-bold">{{ service.title }}</h5>
            <p class="text-muted">{{ service.description }}</p>

            <!-- Read More Button -->
            <b-button
              
              class="mt-3 button-color"
              @click="readMore(service)"
            >
              Read More
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "ServicesPage",
  data() {
    return {
      services: [
        {
          title: "Man Guarding",
          description: "Our success anchors on professionalism, competence and high quality service delivery through the use of well trained personnel and effective monitoring system.",
          icon: "shield-lock",
          link: "/services/man-guarding" // This matches /services/:id
        },
        {
          title: "Mobile Response",
          description: "24/7 monitoring with advanced CCTV installation services.",
          icon: "camera-video",
          link: "/services/mobile-response"
        },
        {
          title: "Protocol Service",
          description: "Modern alarm systems to protect your property.",
          icon: "bell",
          link: "/services/protocol-service"
        },
        {
          title: "Security Consultancy",
          description: "Modern alarm systems to protect your property.",
          icon: "bell",
          link: "/services/security-consultancy"
        },
        {
          title: "Escort Service",
          description: "Modern alarm systems to protect your property.",
          icon: "bell",
          link: "/services/Escort-service"
        },
        {
          title: "Electonic Security",
          description: "Modern alarm systems to protect your property.",
          icon: "bell",
          link: "/services/Electronic-security" 
        },
      ]
    };
  },
  methods: {
    readMore(service) {
      // If using Vue Router
      this.$router.push(service.link);
    }
  }
};

</script>

<style scoped>
.services {
  background: #f8f9fa;
}

.service-card {
  border: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px #990000 !important;
}
.button-color{
  background-color: #990000 !important;
  color: #ffff;
}
.button-color:hover{
  background-color: #4D4D4D !important;
  color: #ffff;
}
.color-bar{
  color: #990000 !important;
}
</style>
